import { Toast } from "primereact/toast";
import React, {useEffect, useRef } from "react";

const GLOBAL_ALERT_EVENT_NAME = "EasasGlobalAlertEvent"


export default function EasasGlobalAlerts() {
    const toastRef = useRef<Toast>(null);

    useEffect(() => {
        const listener = (e: EasasGlobalAlertEvent) => {
            toastRef.current?.show({
                severity: e.detail.type,
                summary: e.detail.message,
                detail: e.detail.detail,
                life: 4000,
            });
        }

        window.addEventListener(GLOBAL_ALERT_EVENT_NAME, listener as EventListener)
        return () => {
            window.removeEventListener(GLOBAL_ALERT_EVENT_NAME, listener as EventListener)
        }
    }, []);

    return <Toast ref={toastRef}/>
}

export function easasAlert(message: string, detail?: string, type: "info" | "warn" | "error" | "success" = "info") {
    dispatchEvent(new EasasGlobalAlertEvent({message, detail, type}))
}

class EasasGlobalAlertEvent extends CustomEvent<EasasGlobalAlertEventDetail> {
    constructor(msg: EasasGlobalAlertEventDetail) {
        super(GLOBAL_ALERT_EVENT_NAME, { detail: msg });
    }
}

interface EasasGlobalAlertEventDetail {
    message: string,
    detail?: string,
    type: "info" | "warn" | "error" | "success",
}